// Dtos
import { SubscriptionPlanDto } from "../../api/dtos/SubscriptionPlan.dto";

import { Price } from "./Price";
import { SubscriptionPlanFeature } from "./SubscriptionPlanFeature";

import { PlanFormModel } from "../form";

export class SubscriptionPlan {
  id: number;
  name: string;
  description: string;
  recommended: boolean;
  active: boolean;
  allowedNumberOfBranches: number;
  accessToAnalytics: boolean;
  givesPremiumAccess: boolean;
  trialPeriodDays: number;
  perBookingFee: number;
  contactOnly: boolean;
  // Contact-only plans have no price.
  price: Price | null;
  subscriptionPlanFeatures: SubscriptionPlanFeature[];

  constructor(entity: SubscriptionPlanDto) {
    this.id = entity.id;
    this.name = entity.name;
    this.description = entity.description;
    this.recommended = entity.recommended;
    this.active = entity.active;
    this.allowedNumberOfBranches = entity.allowed_number_of_branches;
    this.accessToAnalytics = entity.access_to_analytics;
    this.givesPremiumAccess = entity.gives_premium_access;
    this.trialPeriodDays = entity.trial_period_days || 0;
    // Cents -> dollars, same as Price.
    this.perBookingFee = entity.per_booking_fee
      ? entity.per_booking_fee / 100
      : 0;
    this.contactOnly = entity.contact_only || false;
    this.price = entity.price ? new Price(entity.price) : null;
    this.subscriptionPlanFeatures = entity.subscription_plan_features.map(
      (spf) => new SubscriptionPlanFeature(spf)
    );
  }

  generateForm(): PlanFormModel {
    return {
      name: this.name,
      description: this.description,
      price: this.price ? this.price.unitAmount : 0,
      allowedNumberOfBranches: this.allowedNumberOfBranches,
      accessToAnalytics: this.accessToAnalytics,
      givesPremiumAccess: this.givesPremiumAccess,
      trialPeriodDays: this.trialPeriodDays,
      perBookingFee: this.perBookingFee,
      contactOnly: this.contactOnly,
      subscriptionPlanFeatures: this.subscriptionPlanFeatures.map((feature) => {
        return {
          subscriptionFeatureId: feature.subscriptionPlanFeature.id,
          title: "",
          supported: feature.supported,
        };
      }),
    };
  }
}
